import { normalize } from 'normalizr';

import {
  annotationSchema,
  channelSchema,
  channelEventSchema,
  commentSchema,
  shareSchema,
  taskSchema,
} from './entities';

export const types = {
  ANNOTATION_RECEIVE: 'chat/entities/ANNOTATION_RECEIVE',
  CHANNEL_RECEIVE: 'chat/entities/CHANNEL_RECEIVE',
  CHANNEL_EVENT_RECEIVE: 'chat/entities/CHANNEL_EVENT_RECEIVE',
  CHANNELS_RECEIVE: 'chat/entities/CHANNELS_RECEIVE',
  COMMENT_RECEIVE: 'chat/entities/COMMENT_RECEIVE',
  ENTITIES_STORE_INIT: 'chat/entities/ENTITIES_STORE_INIT',
  SHARE_RECEIVE: 'chat/entities/SHARE_RECEIVE',
  TASK_RECEIVE: 'chat/entities/TASK_RECEIVE',
};

export const entitiesStore = {
  init: () => ({
    type: types.ENTITIES_STORE_INIT,
  }),
  receiveAnnotation: (payload) => ({
    type: types.ANNOTATION_RECEIVE,
    payload: {
      ...normalize(payload, annotationSchema),
    },
  }),
  receiveChannel: (payload) => ({
    type: types.CHANNEL_RECEIVE,
    payload: {
      ...normalize(payload, channelSchema),
    },
  }),
  receiveChannels: (payload) => ({
    type: types.CHANNELS_RECEIVE,
    payload: {
      ...normalize(payload, [channelSchema]),
    },
  }),
  receiveComment: (payload) => ({
    type: types.COMMENT_RECEIVE,
    payload: {
      ...normalize(payload, commentSchema),
    },
  }),
  receiveShare: (payload) => ({
    type: types.SHARE_RECEIVE,
    payload: { ...normalize(payload, shareSchema) },
  }),
  receiveChannelEvent: (payload) => ({
    type: types.CHANNEL_EVENT_RECEIVE,
    payload: { ...normalize(payload, channelEventSchema) },
  }),
  receiveTask: (payload) => ({
    type: types.TASK_RECEIVE,
    payload: { ...normalize(payload, taskSchema) },
  }),
};
